import React, { useState, useEffect } from 'react';
import './Causes.css';

const contentData = [
  {
    title: "Bacterial Invasion",
    text: "Bacteria are the primary culprits behind mastitis- Staphylococcus, Streptococcus and E. coli. These pathogens enter the udder through the teat canal, often during or after milking. Without proper hygiene, they can multiply rapidly and trigger infection.",
    img: "/images/cause1.jpg"
  },
  {
    title: "Poor Milking Hygiene",
    text: "Using dirty hands, reusable cloths, or unsanitized milking machines creates ideal conditions for bacterial spread. Inconsistent pre- and post-milking teat disinfection also allows pathogens to pass from cow to cow — increasing herd-wide infection risk.",
    img: "/images/cause2.jpg"
  },
  {
    title: "Teat and Udder Injuries",
    text: "Cracks, cuts, or bruises on the udder or teat open the door for bacterial entry. Rough handling, over-milking, or ill-fitted machines can damage the teat, weakening the cow’s natural defenses and accelerating infection.",
    img: "/images/cause3.jpg"
  },
  {
    title: "Unsanitary Housing/Farm Conditions",
    text: "Moist, dirty bedding and manure buildup provide a breeding ground for mastitis-causing bacteria. When cows lie down, their udders come into direct contact with these surfaces — raising the risk of infection even before milking starts.",
    img: "/images/cause4.jpg"
  },
  {
    title: "Weakened Immune Response",
    text: "Stress, poor nutrition, or concurrent illnesses can suppress a cow’s immune system. When natural defenses are low, even minor bacterial exposure can lead to full-blown mastitis. Young and old animals are especially vulnerable.",
    img: "/images/cause5.jpg"
  }
];

const Causes = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [visible, setVisible] = useState(true);

  // Smooth slide change: fade out → update → fade in
  const goTo = (index) => {
    setVisible(false);
    setTimeout(() => {
      setCurrentIndex((index + contentData.length) % contentData.length);
      setVisible(true);
    }, 350);
  };

  const goPrev = () => goTo(currentIndex - 1);
  const goNext = () => goTo(currentIndex + 1);

  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(() => {
      goTo(currentIndex + 1);
    }, 5500);
    return () => clearInterval(interval);
  }, [isPaused, currentIndex]);

  return (
    <section id="causes" className="causes-section" data-aos="fade-up">
      <div className={`causes-container${visible ? ' causes-visible' : ' causes-hidden'}`}>
        <div className="text-side">
          <h2>{contentData[currentIndex].title}</h2>
          <p>{contentData[currentIndex].text}</p>
        </div>
        <div className="image-side">
          <img src={contentData[currentIndex].img} alt={contentData[currentIndex].title} />
        </div>
      </div>

      <div className="causes-controls">
        {/* Left arrow */}
        <button className="causes-arrow" onClick={goPrev} aria-label="Previous">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
          </svg>
        </button>

        {/* Pause / Resume */}
        <button
          className="causes-play-pause"
          onClick={() => setIsPaused(p => !p)}
          aria-label={isPaused ? 'Resume slideshow' : 'Pause slideshow'}
        >
          {isPaused ? (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="15" height="15">
              <path d="M8 5v14l11-7z"/>
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="15" height="15">
              <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
            </svg>
          )}
        </button>

        {/* Right arrow */}
        <button className="causes-arrow" onClick={goNext} aria-label="Next">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
          </svg>
        </button>
      </div>
    </section>
  );
};

export default Causes;
